(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.MSProjectPlannerPersistence = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const KEY = 'ms-project-planner-recovery';
  const VERSION = 1;
  const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  const MAX_BYTES = 500000;

  function validArea(area) {
    return area && typeof area === 'object' && !Array.isArray(area) &&
      typeof area.id === 'string' && area.id.length > 0 &&
      Number.isSafeInteger(area.number) && area.number > 0 &&
      typeof area.name === 'string' && area.inputs &&
      typeof area.inputs === 'object' && !Array.isArray(area.inputs) &&
      area.inputs.measurementInputsByMethod &&
      typeof area.inputs.measurementInputsByMethod === 'object' &&
      !Array.isArray(area.inputs.measurementInputsByMethod) &&
      area.inputs.relatedMaterials && typeof area.inputs.relatedMaterials === 'object' &&
      !Array.isArray(area.inputs.relatedMaterials) &&
      [null, 'rectangle', 'round-area', 'round-border', 'triangle', 'known-square-footage'].includes(area.inputs.measurementMethod) &&
      (area.inputs.materialId === null || typeof area.inputs.materialId === 'string') &&
      (area.inputs.purchaseMethod === null || ['bulk', 'bags'].includes(area.inputs.purchaseMethod));
  }

  function validState(state, revision, core) {
    if (!state || state.schemaVersion !== core.SCHEMA_VERSION ||
        state.configRevision !== core.CONFIG_REVISION ||
        !state.project || typeof state.project.id !== 'string' ||
        typeof state.project.name !== 'string' ||
        !Array.isArray(state.areas) || !state.areas.length ||
        !state.areas.every(validArea) ||
        !state.ui || typeof state.ui.activeAreaId !== 'string') return false;
    const ids = state.areas.map(area => area.id);
    const numbers = state.areas.map(area => area.number);
    if (new Set(ids).size !== ids.length || new Set(numbers).size !== numbers.length ||
        !ids.includes(state.ui.activeAreaId) ||
        !Number.isSafeInteger(state.nextAreaNumber) ||
        state.nextAreaNumber <= Math.max(...numbers)) return false;
    if (revision !== null && (!revision || typeof revision !== 'object' ||
        !ids.includes(revision.areaId) || !validArea(revision.committedArea) ||
        revision.committedArea.id !== revision.areaId ||
        revision.committedArea.number !== state.areas.find(area => area.id === revision.areaId).number)) return false;
    return true;
  }

  function create(storage, core, now) {
    const currentTime = typeof now === 'function' ? now : Date.now;
    function clear() {
      try { storage.removeItem(KEY); } catch (_) { /* Storage may be unavailable. */ }
    }
    function load() {
      try {
        const raw = storage.getItem(KEY);
        if (!raw) return null;
        if (raw.length > MAX_BYTES) { clear(); return null; }
        const record = JSON.parse(raw);
        const age = currentTime() - record.savedAt;
        if (record.version !== VERSION || !Number.isFinite(record.savedAt) ||
            age < 0 || age > MAX_AGE_MS || !validState(record.state, record.revision, core)) {
          clear();
          return null;
        }
        return {state: record.state, revision: record.revision};
      } catch (_) {
        clear();
        return null;
      }
    }
    function save(state, revision) {
      if (!validState(state, revision, core)) return false;
      try {
        const value = JSON.stringify({version: VERSION, savedAt: currentTime(), state, revision});
        if (value.length > MAX_BYTES) return false;
        storage.setItem(KEY, value);
        return true;
      } catch (_) { return false; }
    }
    return Object.freeze({load, save, clear});
  }

  return Object.freeze({KEY, VERSION, MAX_AGE_MS, validState, create});
});
